import React from "react";
import "./BattleSelectionCard.css";
import battleLogoFallback from "../../assets/images/battleLogo.png";
import bgImageFallback from "../../assets/images/s2.png";

const BattleSelectionCard = ({ battles = [], isLoading = false, onSelectBattle }) => {
  const items = isLoading
    ? Array.from({ length: 2 }).map((_, index) => ({
        id: `skeleton-${index}`,
        title: "Loading...",
        description: "Loading battle details",
        image: bgImageFallback,
        logo: battleLogoFallback,
        isSkeleton: true,
      }))
    : battles;

  return (
    <section className="botd-section" aria-busy={isLoading}>
      <h2 className="botd-heading">Battles of the Day</h2>

      <div className="botd-grid">
        {items.map((battle) => (
          <button
            type="button"
            className="botd-card"
            key={battle.id}
            onClick={() => onSelectBattle?.(battle)}
            disabled={battle.isSkeleton}
          >
            <img
              src={battle.image || bgImageFallback}
              alt={battle.title}
              className="botd-card-image"
            />

            <div className="botd-overlay"></div>

            {(battle.logo || battleLogoFallback) && (
              <img
                src={battle.logo || battleLogoFallback}
                alt=""
                className="botd-card-logo"
              />
            )}

            <div className="botd-card-content">
              <h3>{battle.title}</h3>
              <p>{battle.description}</p>
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};

export default BattleSelectionCard;
